import { callbackSite } from './consts-callback';

export function getRedirectApp() {
	return `${callbackSite}`;
}
